import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';

// Styling for the footer
const FooterContainer = styled.footer`
  background-color: #282c34;
  padding: 20px;
  color: white;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100%;
`;

const SocialMediaContainer = styled.div`
  margin-top: 10px;
`;

const SocialMediaIcon = styled.a`
  color: white;
  margin: 0 15px;
  font-size: 24px;
  transition: color 0.3s;

  &:hover {
    color: #61dafb;
  }
`;

const Footer = () => {
    return (
        <FooterContainer>
            <SocialMediaContainer>
                <SocialMediaIcon href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faFacebook}/>
                </SocialMediaIcon>
                <SocialMediaIcon href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faInstagram}/>
                </SocialMediaIcon>
            </SocialMediaContainer>
            <p>&copy; {new Date().getFullYear()} Prone Paddle Sport Challenge</p>
            <p>All Rights Reserved &copy; MeiC</p>
        </FooterContainer>
    );
};

export default Footer;
